import Tick from '@assets/icons/tick.svg'
import Warning from '@assets/icons/warning.svg'
import { useFormContext } from 'react-hook-form'

type Props = {
  name: string
  label?: string
  optional?: boolean
}

const YearInput = ({ name, ...rest }: Props) => {
  const { register, getFieldState, formState } = useFormContext()
  const { error, isTouched, isDirty } = getFieldState(name, formState)

  return (
    <div className="lg:col-span-2 col-span-1" data-gt-name="componentevent">
      <div className="md:col-span-2 lg:col-span-1">
        <label className="block" htmlFor={name}>
          <div className="relative">
            <input
              id={name}
              className={`rounded-input block w-full p-[0.7rem] pr-12 ${
                error && 'border-red'
              } ${!error && isTouched && isDirty && 'border-green'}`}
              type="text"
              placeholder="YYYY"
              aria-invalid={error ? 'true' : 'false'}
              data-gt-action="text-input-interaction"
              data-gt-label={name}
              {...register(name)}
              {...rest}
            />
            {error && (
              <Warning className="absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red" />
            )}
            {!error && isTouched && isDirty && (
              <Tick className="absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green" />
            )}
          </div>
        </label>
        {error && (
          <p className="text-red text-tiny mt-1" role="alert">
            {error.message}
          </p>
        )}
      </div>
    </div>
  )
}

export default YearInput
